import { cn } from "@/lib/utils"
import { HashSidebarItemType } from "./HashSidebarItem"
import HashSidebarItem from "./HashSidebarItem"
import { DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog"

export interface HashSidebarProps {
  items: HashSidebarItemType[]
  currentSection: string
  baseHash: string
  title: string
  collapsed?: boolean
}

function HashSidebar(props: HashSidebarProps) {
  // TODO: Substituir por dark mode
  const dark = true

  return (
    <div className={cn("flex h-full w-[300px] flex-col p-2 shadow-aside z-10 transition-all duration-150", props.collapsed && "w-0 p-0 shadow-none")}>
      {!props.collapsed && (
        <>
          <DialogHeader className="min-h-10 px-6 pt-5 pb-0">
            <DialogTitle className="text-xl font-medium">{props.title}</DialogTitle>
            <DialogDescription />
          </DialogHeader>
          <div className="flex flex-col gap-1.5 p-4">
            {props.items.map((item) => (
              <HashSidebarItem {...item} key={item.label} dark={dark} active={item.to === props.currentSection} baseHash={props.baseHash} />
            ))}
          </div>
        </>
      )}
    </div>
  )
}

export default HashSidebar
